export default {
  select_size: 'Seleziona una dimensione',
  required: 'Obbligatorio',
  required_missing: 'Obbligatorio — effettua una selezione',
  optional: 'Facoltativo',
  select_up_to: 'Seleziona fino a {{maxCount}}',
};
